import React, { useMemo, FC } from 'react';
import { useContext } from 'react';

export interface ListContextProps {
	list: JSX.Element[];
}

const ListContext = React.createContext<ListContextProps>({
	list: [],
});
ListContext.displayName = 'ListContext';

const ListContextProvider: FC<ListContextProps> = ({ list = [], children }) => {
	const value = useMemo(() => ({ list }), [list]);
	return <ListContext.Provider value={value}>{children}</ListContext.Provider>;
};
ListContextProvider.displayName = 'ListContextProvider';

export { ListContextProvider };

const useListContext = () => {
	return useContext(ListContext);
};

export { useListContext };
